export const FORM_NAMES = {
  LOGIN: 'login',
  REGISTER: 'register',
  SUBSCRIPTION: 'subscription',
  SHIPPING: 'shipping',
  PAYMENT: 'payment'
};

export const FIELD_NAMES = {
  [FORM_NAMES.SUBSCRIPTION]: {
    INTERVAL: 'interval'
  }
};

export const FORMS = {
  SUBSCRIPTION: {
    NAME: 'subscription',
    FIELDS: {
      INTERVAL: 'interval'
    }
  },
  REGISTER: {
    NAME: 'register'
  },
  SHIPPING: {
  },
  THEME: {
    NAME: 'theme'
  }
};

export const UNITED_STATES = [ 'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ];
